export default {"src":"/_next/static/media/plus.fd6107a3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};